import { takeEvery, select, put, call } from "redux-saga/effects";
import { MasterSelector } from "redux/selector";
import { openErrorModal } from "redux/reducers/central-modal";
import { alertError } from "redux/reducers/master";
import { LoggingAPI } from "services/logging-server";
import { message as antdMessage } from "antd";
import { DeviceUtil } from "utils/device-util";

// const FAILURE_REGEX = new RegExp(`_${FAILURE}$|^FAILURE$`);
const alertErrorAction = alertError.type;
const failCase = ["fail", "failure", "error"].join("|");
const FAILURE_REGEX = new RegExp(`(${failCase})$|^${alertErrorAction}$`, "i");
const NO_MESSAGE_FOR_CODE = (errorCode) => `[code: ${errorCode}]`;

function* watchError({ payload: error }) {
  try {
    if (error) {
      const {
        type,
        title,
        messageId, // client throw message id error
        code, // error code on config ... ( must :: no message provided)
        message, // Normal Client Error
        params, // params: for format config message only
        actions, // actions payload interact each modal
        state = {}, // payload anything
        ignore, // skip process just let it to reducer
        modalMessage,
        slideMessage, // specific message ( modalMessage: for error dialog || slideMessage: for message slide in at top right screen )
        isHttpError,
        isClientNoPopup,
      } = error;

      if (!ignore) {
        // force ignore
        // business error
        if (modalMessage || slideMessage) {
          if (modalMessage) {
            yield put(openErrorModal({ code, actions, state: { ...state, message: modalMessage, type, title } }));
          } else {
            antdMessage.error(slideMessage);
          }
        } else if (code) {
          const errorConst = yield select(MasterSelector.errorConst);
          const errorMsgConfig = errorConst?.[code] ?? NO_MESSAGE_FOR_CODE(code);
          yield put(
            openErrorModal({ code, actions, state: { ...state, params, message: errorMsgConfig, type, title } })
          );
        } else if (messageId) {
          yield put(openErrorModal({ messageId, actions, state: { ...state, params, type, title } }));
        } else {
          // IF :: No Code, No ModalMessage, No SlideMessage are provided. then it's
          // - Client JS error on saga
          // - Default Error Dialog
          if (!isHttpError && message) {
            try {
              yield call(
                LoggingAPI.error({
                  message: JSON.stringify(message),
                  deviceInfo: DeviceUtil.getDeviceInfo(),
                })
              );
            } catch (e) {
              /* do nothing */
            }
          }
          //* If isHttpError = true then force default display error 1000 (server error)
          //* If isHttpError = false then force default display error 1006 (client error)
          if (!isClientNoPopup) {
            yield put(openErrorModal({ actions, state: { message: null, isHttpError } }));
          }
        }
      }
    }
  } catch (error) {
    console.error(error);
  }
}

const errorSaga = [takeEvery((action) => FAILURE_REGEX.test(action.type), watchError)];

export default errorSaga;
